import type { IconType } from "@justhome/react-ui";

export interface TopBarSpec {
  key: string;
  mobileKey?: string;
  href?: string;
  icon: IconType;
}

// The bar says the same three things on every page, so it is not CMS content. Only the words
// are: the English site says them in English.
export const TOP_BAR: TopBarSpec[] = [
  {
    key: "topbar_nationwide",
    mobileKey: "topbar_nationwide_short",
    icon: "LocalTwo",
  },
  { key: "topbar_free", icon: "Like" },
  { key: "topbar_phone", href: "tel:03091739560", icon: "PhoneTelephone" },
];

export const toTopBarItems = (t: (key: string) => string) =>
  TOP_BAR.map(({ key, mobileKey, href, icon }) => ({
    label: t(key),
    mobileLabel: mobileKey ? t(mobileKey) : undefined,
    href,
    icon,
  }));
